// Quick-pick looks for the last-resort screenshot fallback.
//
// The field itself is FREE TEXT — the operator types any look ("neon cyberpunk night city")
// and the worker evaluates the words: they are welded onto every Unsplash search and a
// treatment is read out of them. These are only the shortcuts, the looks the worker has a
// hand-tuned tone for, so picking one fills the box with its id.
//
// MIRROR of back/helpers/imageFallbackThemes.js, which mirrors the worker's
// services/imageFallbackThemes.js — `__tests__/imageFallbackThemes.test.js` fails on drift,
// because a shortcut the worker has not tuned would search but come back untreated.
export const IMAGE_FALLBACK_THEMES = [
  { id: '', label: 'None — match the subject only' },
  { id: 'dark', label: 'Dark & moody' },
  { id: 'bright', label: 'Bright & airy' },
  { id: 'corporate', label: 'Corporate / professional' },
  { id: 'industrial', label: 'Industrial / site' },
  { id: 'tech', label: 'Technology / abstract' },
  { id: 'nature', label: 'Nature / outdoors' },
  { id: 'warm', label: 'Warm / golden hour' },
  { id: 'mono', label: 'Black & white' },
];
export const IMAGE_FALLBACK_THEME_IDS = IMAGE_FALLBACK_THEMES.map((t) => t.id);
